import "../scss/main.scss";
import "core-js/stable";

import { HeaderNavigation } from "./headerNavigation";
import { HeaderSlider } from "./headerSlider";
import { SideSlider } from "./sideSlider";
import { scrollTo } from "./scrollTo";
import { HistoryDisplay } from "./historyDisplay";
import { Selector } from "./selector";

// prevent firefox from caching pages on back button
window.onunload = function() {};

(function() {
	new HeaderNavigation({
		el: ".header",
		burger: ".header__burger",
		mobileContainer: ".header__navigation-content",
		headerOpenedClass: "header--opened",
		bodyClass: "body--fixed",
		mobileViewport: 960
	});

	if (document.querySelector(".header-slider__container")) {
		new HeaderSlider({
			el: ".header-slider__container",
			currentNumber: ".header-slider__slide-current-number",
			mobileViewport: 960
		});
	}

	if (document.querySelector(".side-slider")) {
		new SideSlider({
			el: ".side-slider",
			slideActiveClass: ".side-slider-active-slide",
			nextEl: ".side-slider-next",
			prevEl: ".side-slider-prev"
		});
	}

	document.querySelectorAll("[data-scroll-to]").forEach((el) => {
		el.addEventListener("click", (e) => {
			e.preventDefault();

			const scrollTarget = el.getAttribute("data-scroll-to");
			const scrollOffset = el.getAttribute("data-scroll-offset") || 0;
			const scrollEl = isNaN(scrollTarget)
				? document.querySelector(scrollTarget)
				: parseInt(scrollTarget);

			scrollTo(scrollEl, scrollOffset);
		});
	});

	document.querySelectorAll(".history").forEach((el) => {
		new HistoryDisplay({
			$el: el,
			mobileScrollOffset: 60,
			anchorDataName: "data-stage",
			bigYear: ".history__big-year",
			bigYearContainerClass: "history__big-year-container",
			bigYearContainerActiveClass: "history__big-year-container--active",
			bigYearContainerDeactivatedClass:
				"history__big-year-container--deactivated",
			digitContainerClass: "history__digit-container"
		});
	});

	document.querySelectorAll(".products__category-select").forEach((el) => {
		new Selector({
			$el: el
		});
	});
})();
